<template>
    <ActionItemsList :action-items="data.action_params.action_items" :message-id="messageId" @check="handleCheck" />
</template>

<script setup lang="ts">
import ActionItemsList from "~vue/ActionItemsList.vue";
import { inject } from "vue";

import type { GlobalProperties } from "./appTypes";
import type { ParseActionsActionItemsAction } from "./types/chat";
import { logUserInteraction } from "./utils/logUtils";

type ChatActionActionItemsProps = { data: ParseActionsActionItemsAction; messageId: number; lineIdx: number };

const { data, messageId, lineIdx } = defineProps<ChatActionActionItemsProps>();
const coachingSessionUuid = inject<string>("coachingSessionUuid");
const { emitter } = inject<GlobalProperties>("globalProperties", {} as GlobalProperties);

const handleCheck = (actionItemIndex: number) => {
    const item = data.action_params.action_items[actionItemIndex];
    item.checked = !item.checked;

    const action_data = {
        subaction: "check_item",
        item_index: actionItemIndex,
        message_id: messageId,
        lineIdx: lineIdx,
        action_params: data.action_params,
        action_state: {
            submitted: false,
        },
    };
    emitter.emit("action_items", action_data);
    logUserInteraction("action_items_checked", {}, coachingSessionUuid);
};
</script>
